import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import autoShowModal from '../modifiers/auto-show-modal.js';

export default class PermissionDialog extends Component {
  @service intl;

  <template>
    <dialog
      class="modal"
      {{autoShowModal}}
      {{on "cancel" @onClose}}
      {{on "close" @onClose}}
    >
      <form
        aria-label="modal"
        method="dialog"
        class="modal-box"
        {{on "submit" @onConfirm}}
      >
        <h2 class="text-lg text-primary font-semibold mb-2">
          {{@title}}
        </h2>
        <p>
          {{@message}}
        </p>
        <p class="fieldset-label text-sm">
          {{@description}}
        </p>
        <div class="modal-action">
          <button type="submit" class="btn btn-primary uppercase">
            {{@action}}
          </button>
        </div>
      </form>
      <form aria-label="backdrop" method="dialog" class="modal-backdrop">
        <button type="submit" />
      </form>
    </dialog>
  </template>
}
